module.exports = __webpack_public_path__ + "media/images/kids7-b00e0af5cf7f026da147390923754ced.jpg";